import React, { useState } from 'react'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { colors } from '@resiliatech/birdsong'

import { SingleGoalUpdate } from 'Generated/graphql-types'
import { useAppState } from 'Context/AppContext/AppContext'
import {
  Actions,
  Avatar,
  Card,
  Description,
  Details,
  TopHalf,
  UserName,
  AssociatedTask,
} from './Update.styled'
import UserAvatar from '../../../../SharedComponents/UserAvatar'

type Props = {
  update: SingleGoalUpdate
  onDeleteUpdate: () => void
  onEditUpdate: () => void
}

const iconStyles = {
  color: colors.interactive.primaryEnabled,
  cursor: 'pointer ',
  fontSize: 'large',
}

export const Update = ({ update, onDeleteUpdate, onEditUpdate }: Props) => {
  const { userConfig: { id: userId } = {} } = useAppState()
  const lastUpdatedUser = {
    id: update.lastUpdatedUserId,
    firstName: update.lastUpdatedUserFirstname,
    lastName: update.lastUpdatedUserLastname,
  }
  const associatedTaskTitle = update.taskTitle
  const isEditable = userId === lastUpdatedUser.id

  return (
    <Card key={update.id}>
      <TopHalf>
        <Details>
          <Avatar>
            <UserAvatar
              user={lastUpdatedUser}
              tooltipText={`${update.lastUpdatedUserFirstname} ${update.lastUpdatedUserLastname}`}
            />
          </Avatar>
          <div>
            <UserName>
              {`${update.lastUpdatedUserFirstname} ${update.lastUpdatedUserLastname}`}
            </UserName>
            {associatedTaskTitle && (
              <AssociatedTask>FROM TASK {associatedTaskTitle}</AssociatedTask>
            )}
          </div>
        </Details>
        {isEditable && (
          <Actions className='goal-comment-actions'>
            <EditOutlinedIcon onClick={onEditUpdate} sx={iconStyles} />
            <DeleteOutlineOutlinedIcon
              onClick={onDeleteUpdate}
              sx={iconStyles}
            />
          </Actions>
        )}
      </TopHalf>
      <Description>{update.description}</Description>
    </Card>
  )
}
